import React, { FunctionComponent, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faLink } from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from "react-bootstrap";
import { Intervention } from "../../../../../../store/onboarding/cases/types";
import { Portal } from "react-portal";

type OwnProps = {
  intervention: Intervention;
};

type Props = OwnProps;

const PdfBtn: FunctionComponent<Props> = ({ intervention }) => {
  const attachments = [...intervention.attachments, ...intervention.checklist_items.flatMap((ci) => ci.attachments)];
  const attachmentUrl = useMemo(() => {
    let attachmentURL = '';
    if(window.location.host.includes('localhost')) {
      attachmentURL = 'http://localhost:8000'
    } else if (window.location.host === 'staging.readycoach.net'){
      attachmentURL = 'https://stage-api.readycoach.net'
    }
    return attachmentURL;
  },[attachments])

  const onlyPDFs = useMemo(() => {
    return attachments.filter(att => att.attachment_url);
  }, [attachments])
  const onlyURLs = useMemo(() => {
    return attachments.filter(att => att.url);
  }, [attachments])
  // const downloadFile = (attachment_url: string) => (event: React.FormEvent) => {
  //   event.preventDefault();
  //   if (attachment_url && attachment_url.startsWith('/media')){
  //     let attachmentURL = 'http://localhost:8000' + attachment_url
  //     if (window.location.host === 'staging.readycoach.net'){
  //       attachmentURL = 'https://stage-api.readycoach.net' + attachment_url
  //     } else if (window.location.host === 'app.readycoach.net'){
  //       attachmentURL = 'https://api.readycoach.net' + attachment_url
  //     } else if (window.location.host === 'pre-prod.readycoach.net'){
  //       attachmentURL = 'https://pre-prod-api.readycoach.net' + attachment_url
  //     }
  //     window.open(attachmentURL,"_blank")
  //   }
  // }
  const [openDropdown, setOpenDropdown] = useState<null | 'pdf' | 'url'>(null);
  let attachmentHtml = null;
  if (!attachments.length) {
    attachmentHtml = <div />;
  } else {
    if (attachments.length === 1) {
      attachmentHtml = 
        <>  
          {attachments[0].url ? (
            <a
              href={attachments[0].url!}
              target="_blank"
              rel="noopener noreferrer"
              className="whiteBtnSm withInnerBlueSvg"
              onClick={(event) => {
                event.stopPropagation();
              }}
            >
              <FontAwesomeIcon icon={faLink}/>
              URL
            </a> ) 
          : null}
          {attachments[0].attachment_url ? (
            <a
              href={attachmentUrl + attachments[0].attachment_url!}
              target="_blank"
              rel="noopener noreferrer"
              className="blueBtnSm withInnerWhiteSvg"
              onClick={(event) => {
                event.stopPropagation();
              }}
              style={{ color: '#fff', textDecoration: 'none' }}
              // onClick={downloadFile(attachments[0].attachment_url!)}
            >
              <FontAwesomeIcon icon={faDownload} style={{ color: '#fff' }}/>
              PDF
            </a> ) : null}

        </>;
    }
    if(attachments.length > 1) {
      attachmentHtml = (
        <div className="d-flex align-items-center" style={{ gap: 8 }}>
           {onlyURLs.length > 0 ? (
            <Dropdown
              show={openDropdown === 'url'}
              onToggle={(isOpen) => setOpenDropdown(isOpen ? 'url' : null)}
              onClick={(e: any) => {
                e.stopPropagation();
                setOpenDropdown(openDropdown === 'url' ? null : 'url');
              }}
            >
              <Dropdown.Toggle as="button" className="whiteBtnSm withInnerBlueSvg" id="pdf-files-dropdown">
                <FontAwesomeIcon icon={faLink} className="mr-2" />URL
              </Dropdown.Toggle>
              {onlyURLs.length > 1 ? (
                  <Dropdown.Menu className="custom-dropdown-menu">
                    {onlyURLs.map((attachment) => (
                      <Dropdown.Item as="a" key={attachment.id}
                        href={attachment.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => e.stopPropagation()}
                        style={{
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          maxWidth: 120,
                          minWidth: 120,
                          overflowWrap: 'break-word',
                        }}
                      >
                        {attachment.title}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                ) : null}
              </Dropdown>
            ) : null}
          {onlyPDFs.length > 0 ? (
            <Dropdown
              show={openDropdown === 'pdf'}
              onToggle={(isOpen) => setOpenDropdown(isOpen ? 'pdf' : null)}
              onClick={(e: any) => {
                e.stopPropagation();
                setOpenDropdown(openDropdown === 'pdf' ? null : 'pdf');
              }}
            >
              <Dropdown.Toggle as="button" className="blueBtnSm withInnerWhiteSvg" id="pdf-files-dropdown">
                <FontAwesomeIcon icon={faDownload} className="mr-2" style={{ color: '#fff' }} />PDF
              </Dropdown.Toggle>
              {onlyPDFs.length > 1 ? (
                <Dropdown.Menu className="custom-dropdown-menu">
                  {onlyPDFs.map((attachment) => (
                    <Dropdown.Item as="a" key={attachment.id}
                      href={attachmentUrl + (attachment.attachment_url)}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={e => e.stopPropagation()}
                      style={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        maxWidth: 120,
                        minWidth: 120,
                        overflowWrap: 'break-word',
                      }}
                    >
                      {attachment.title}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              ): null}
            </Dropdown>
          ) : null}

        </div>
      );
    }
  }
  return attachmentHtml;
};

export default PdfBtn;
